import { parsePhoneNumberFromString, getExampleNumber, AsYouType } from "libphonenumber-js/max";
import examples from "libphonenumber-js/examples.mobile.json";

import { ALLOWED_COUNTRIES, DEFAULT_COUNTRY } from "./flagsConfig";

const PHONE_PLACEHOLDER_CACHE = {};

// Parse the phone number with countryCode have '+' in it
export const parsePhoneNumberWithCountryCode = (fullPhone) => {
  if (!fullPhone) {
      return "";
    }
    const phoneNumberWithCountryCode = fullPhone.includes('+') ? fullPhone : '+' + fullPhone;

    return phoneNumberWithCountryCode;
}

// Normalize phone number by removing non-digit characters for consistent processing
export const normalizePhoneNumber = (phone) => (phone || '').replace(/\D/g, '');

// validate phonenumber and number already exist for phone number updation.
export const isValidPhoneNumber = (fullPhone) => {
  if (!fullPhone) return false;

  const phoneNumber = parsePhoneNumberFromString(fullPhone);

  if (!phoneNumber) {
    return false;
  }

  const type = phoneNumber.getType();

  return ((phoneNumber.isValid()) && (type === "MOBILE" || type === "FIXED_LINE_OR_MOBILE"));
};

// Normalize the country code from unsupported country from hubspot.
export const normalizeCountryCode = (iso) => {
  if (!iso) return DEFAULT_COUNTRY;
  const normalized = iso.toLowerCase();
  return ALLOWED_COUNTRIES.includes(normalized)
    ? normalized
    : DEFAULT_COUNTRY;
};

// Parse the given phone number input with countrycode.
export const parsePhoneInput = (value, meta) => {
  if (!value) {
    return {
      iso: DEFAULT_COUNTRY,
      countryCode: "",
      nationalNumber: "",
      fullPhone: "",
    };
  }

  const parsedNumber = parsePhoneNumberFromString(value);

  return {
    iso: meta?.country?.iso2 || DEFAULT_COUNTRY,
    countryCode: parsedNumber ? `+${parsedNumber.countryCallingCode}` : "",
    nationalNumber: parsedNumber ? parsedNumber.nationalNumber : "",
    fullPhone: value,
  };
};

// Get the placeholder according to iso2.
export const getPhonePlaceholderByCountry = (iso2) => {
  if (!iso2) return "Enter phone number";

  if (PHONE_PLACEHOLDER_CACHE[iso2]) {
    return PHONE_PLACEHOLDER_CACHE[iso2];
  }

  const exampleNumber = getExampleNumber(iso2.toUpperCase(), examples);

  const placeholder = exampleNumber ? new AsYouType(iso2.toUpperCase()).input(exampleNumber.nationalNumber) : "Enter phone number";

  PHONE_PLACEHOLDER_CACHE[iso2] = placeholder;
  return placeholder;
};